/*
 * Cloud Store CBD — Page ville (cs-city)
 * - Sticky CTA mobile via IntersectionObserver
 * - Smooth scroll anchors
 */
(function () {
  if (window.__csCityInit) return;
  window.__csCityInit = true;

  // Sticky CTA mobile : visible quand on scroll passé le hero, masqué quand on atteint le CTA final
  function initStickyCta() {
    var sticky = document.querySelector('[data-cs-city-sticky-cta]');
    var hero = document.querySelector('[data-cs-city-hero]');
    var finalCta = document.querySelector('[data-cs-city-final-cta]');
    if (!sticky || !hero) return;

    var heroVisible = true;
    var finalVisible = false;

    var heroObs = new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0.1 });

    var finalObs = finalCta ? new IntersectionObserver(function (entries) {
      finalVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0.05 }) : null;

    heroObs.observe(hero);
    if (finalObs) finalObs.observe(finalCta);

    function update() {
      if (!heroVisible && !finalVisible) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }
  }

  // Smooth scroll pour les anchors internes (#faq, #avis, etc.)
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      var href = anchor.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Click-to-load Google Maps (économise ~500-800ms TBT au load initial)
  function initLazyMap() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cs-map-load]');
      if (!btn) return;
      var wrapper = btn.closest('[data-cs-map-lazy]');
      if (!wrapper) return;
      var src = wrapper.getAttribute('data-map-src');
      var title = wrapper.getAttribute('data-map-title') || 'Carte';
      if (!src) return;
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = title;
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      iframe.setAttribute('allowfullscreen', '');
      wrapper.replaceChildren(iframe);
    });
  }

  // Click-to-copy promo code
  function initCopyCode() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cs-copy-code]');
      if (!btn) return;
      var code = btn.getAttribute('data-cs-copy-code');
      if (!code) return;

      var done = function () {
        btn.classList.add('is-copied');
        clearTimeout(btn._csCopyT);
        btn._csCopyT = setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {
          fallbackCopy(code, done);
        });
      } else {
        fallbackCopy(code, done);
      }
    });
  }

  function fallbackCopy(text, cb) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); cb(); } catch (_) {}
    document.body.removeChild(ta);
  }

  function init() {
    initStickyCta();
    initSmoothScroll();
    initLazyMap();
    initCopyCode();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
